var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0007 1.46919C12.5173 1.68125 12.0022 1.82181 11.4651 1.89006C12.0176 1.56019 12.4393 1.04181 12.6375 0.417C12.1224 0.724125 11.5537 0.941063 10.9475 1.06213C10.4584 0.541313 9.76129 0.21875 9.00079 0.21875C7.52529 0.21875 6.33742 1.41638 6.33742 2.88456C6.33742 3.09581 6.35529 3.29894 6.39917 3.49231C4.18348 3.38425 2.22292 2.32231 0.905857 0.704625C0.67592 1.10356 0.541045 1.56019 0.541045 2.05175C0.541045 2.97475 1.01636 3.79294 1.72486 4.26662C1.29667 4.2585 0.876607 4.13419 0.520732 3.93837C0.520732 3.9465 0.520732 3.95706 0.520732 3.96762C0.520732 5.26275 1.44454 6.3385 2.65598 6.58631C2.43904 6.64563 2.20261 6.67406 1.95723 6.67406C1.78661 6.67406 1.61436 6.66431 1.45267 6.62856C1.79798 7.684 2.77786 8.45994 3.94298 8.48512C3.03623 9.19444 1.88492 9.62181 0.638545 9.62181C0.419982 9.62181 0.210357 9.61206 0.000732422 9.58525C1.18129 10.3466 2.58042 10.7812 4.08923 10.7812C8.99348 10.7812 11.6747 6.71875 11.6747 3.19737C11.6747 3.07956 11.6707 2.96581 11.665 2.85287C12.1939 2.4775 12.6384 2.00869 13.0007 1.46919Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.32a97f46cd9156bbe5934e2d9e3f6ac3.svg";
export { ForwardRef as ReactComponent };